import * as React from 'react';

import { Map, Marker, Tooltip, Viewport } from 'react-leaflet';
import ReactResizeDetector from 'react-resize-detector';

import * as L from 'leaflet';

import 'leaflet/dist/leaflet.css';

import { GoogleTileLayer } from '../';

interface Props {
  className?: string;
  farms: Farm[];
  onFarmClick: (farm: Farm) => void;
}

const DEFAULT_VIEWPORT: Viewport = {
  center: [-37.31013, -59.636838],
  zoom: 6
};

const MARKER_ICON = L.icon({
  iconUrl: require('./marker.svg'),
  iconSize: [38, 95],
  tooltipAnchor: [20, 0]
});

function getValidFarms(allFarms: Farm[]): Farm[] {
  return allFarms
    .filter(farm => farm.geometry)
    .filter(farm => farm.geometry.coordinates)
    .filter(farm => farm.geometry.coordinates[0] && farm.geometry.coordinates[1]);
}

class RootMap extends React.Component<Props> {
  mapRef: L.Map | null;

  handleResize = () => {
    if (!this.mapRef) {
      return;
    }

    this.mapRef.invalidateSize();
  }

  renderFarms() {
    const { farms, onFarmClick } = this.props;
    console.warn(farms);
    return getValidFarms(farms).map((farm, index) => (
      <Marker
        position={[farm.geometry.coordinates[0], farm.geometry.coordinates[1]]}
        icon={MARKER_ICON}
        onClick={() => onFarmClick(farm)}
      >
        <Tooltip position="top" permanent={true}>
          <span>
            <strong>{farm.name}</strong> ({farm.fieldCount} lotes)
          </span>
        </Tooltip>
      </Marker>
    ));
  }

  render() {
    const { children, ...other } = this.props;
    return (
      <Map viewport={DEFAULT_VIEWPORT} ref={ref => this.mapRef = ref && ref.leafletElement || null} {...other}>
        <GoogleTileLayer />
        {this.renderFarms()}
        <ReactResizeDetector
          handleWidth={true}
          handleHeight={true}
          onResize={this.handleResize}
        />
      </Map>
    );
  }
}

export default RootMap;



// WEBPACK FOOTER //
// ./src/components/RootMap/index.tsx